export enum Riwaya {
  Hafs = 'حفص',
  Warsh = 'ورش',
  Qaloon = 'قالون',
  Khalaf = 'خلف',
  AlBazzi = 'البزي',
  AlSoosi = 'السوسي',
  AlDooriKisai = 'الدوري-الكسائي',
  AlDooriAbuAmr = 'الدوري-أبي-عمرو',
  Shuaba = 'شعبة',
  IbnZakwan = 'ابن-ذكوان',
  Hisham = 'هشام',
  IbnJammaz = 'ابن-جماز',
  Yaqoub = 'يعقوب',
}
